import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#experiencia", label: "Sobre" },
  { href: "#areas-de-atuacao", label: "Áreas" },
  { href: "#diferenciais", label: "Diferenciais" },
  { href: "#faq", label: "FAQ" },
  { href: "#contato", label: "Contato" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled ? "bg-brand-primary/95 backdrop-blur-md border-b border-white/10" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-logo">
          <img
            src="/logos/vertical1.png"
            alt="Galleti Advogados"
            className="h-12 w-auto object-contain"
            style={{ filter: "brightness(0) invert(1)" }}
          />
        </a>

        <ul className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="link-underline text-white/85 hover:text-white text-[13px] tracking-[0.18em] uppercase font-medium"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#contato"
          data-testid="nav-cta-button"
          className="hidden lg:inline-flex items-center gap-2 px-6 py-3 text-[12px] tracking-[0.22em] uppercase font-semibold text-brand-primary bg-brand-accent hover:bg-white transition-colors"
        >
          Fale com um especialista
        </a>

        <button
          aria-label="Abrir menu"
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-brand-primary border-t border-white/10" data-testid="mobile-menu">
          <ul className="px-6 py-6 space-y-4">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block text-white/85 text-sm tracking-[0.18em] uppercase"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#contato"
                onClick={() => setOpen(false)}
                className="inline-block mt-2 px-6 py-3 text-[12px] tracking-[0.22em] uppercase font-semibold text-brand-primary bg-brand-accent"
              >
                Fale com um especialista
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
